import { FormItemPropTypes } from './default'

const FormItemColorPickerPropTypes = {
  ...FormItemPropTypes,
}

export default FormItemColorPickerPropTypes
